import React, { useContext, useEffect, useState } from 'react'
import { Outlet, useParams } from 'react-router-dom'

import { getDealer } from '@/services/dealer.service'
import { UserStoreContext } from '@/stores/UserStore'

import { DealerHeader } from './DealerHeader'

const DealerLayout = () => {
  const { id } = useParams()
  const { isWpcExecutive, isDealerUser, isDealerAdmin } = useContext(UserStoreContext)
  const isROServiceUser = isDealerUser && !isDealerAdmin

  const [dealer, setDealer] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    const controller = new AbortController()

    // Clear the previous dealer so the header shows its loading state instead of
    // the old dealer's name while the new one loads. Also clear any prior error
    // so a failure on one dealer doesn't keep the header hidden after switching
    // to a dealer that loads fine.
    setDealer(null)
    setError(null)

    const fetchDealer = async () => {
      const response = await getDealer(
        id,
        () => {},
        setError,
        () => {},
        'group,manufacturer',
        controller.signal,
      )
      // `response` is null when the request was superseded (aborted); ignore it
      // so a stale dealer can never overwrite the current one.
      if (response) setDealer(response)
    }
    fetchDealer()

    return () => controller.abort()
  }, [id])

  return (
    <>
      {!error && (
        <DealerHeader
          dealer={dealer}
          isWpcExecutive={isWpcExecutive}
          isROServiceUser={isROServiceUser}
        />
      )}

      <Outlet context={{ dealer, error }} />
    </>
  )
}

export default DealerLayout
